// extracted by css-extract-rspack-plugin
export default {"printHide":"_a86ae70"};